import { Box } from 'foundations-components/transitional/components/Box';
import DebouncedSearchInputFilter from './DebouncedSearchInputFilter';
import { useIsAnyFilterSet } from '../../hooks/filtersHooks';
import MyTeamFiltersWrapper from './MyTeamFiltersWrapper';
import { TeamsFilterButton, TeamMemberFilterButton } from './Filters';
import UsageTracker from '../../../../utils/UsageTracker';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const CertificationProfileFilters = ({
  store
}) => {
  const {
    state: {
      teams,
      users,
      search
    },
    actions: {
      setTeams,
      setUsers,
      setSearch,
      resetTableState
    }
  } = store;
  const isAnyFilterSet = useIsAnyFilterSet(store, ['teams', 'users']);
  const handleSearchChange = value => {
    setSearch(value);
    // We dont track the search input value here because it's searching by user name
    UsageTracker.track('teamInteraction', {
      action: 'search-input'
    });
  };
  return /*#__PURE__*/_jsxs(MyTeamFiltersWrapper, {
    isAnyFilterSet: isAnyFilterSet,
    onClearAllFilters: resetTableState,
    searchInput: /*#__PURE__*/_jsx(DebouncedSearchInputFilter, {
      onChange: handleSearchChange,
      value: search
    }),
    tableStore: store,
    children: [/*#__PURE__*/_jsx(Box, {
      children: /*#__PURE__*/_jsx(TeamsFilterButton, {
        setTeams: setTeams,
        teams: teams
      })
    }), /*#__PURE__*/_jsx(Box, {
      marginInlineEnd: "600",
      children: /*#__PURE__*/_jsx(TeamMemberFilterButton, {
        setUsers: setUsers,
        users: users
      })
    })]
  });
};
export default CertificationProfileFilters;